module.exports = __webpack_public_path__ + "img/esmeralda-room-4.7d82dc15.jpg";